import { useState, useEffect } from "react";

import './Reports.css';

import { GetStatusGlobal, RegisterStatusGlobal, UnRegisterStatusGlobal } from "../../interface/Global";

import Page_Reports_General from "./general";
import Page_Reports_Units from "./units";
import Page_Reports_Floorplans from "./floorplans";

export default function Page_Reports() {

    // o menu lateral grava a opção escolhida em page_sub, e é ela que decide
    // qual relatório aparece
    const [ pageSub, setPageSub ] = useState<string>(localStorage.getItem('page_sub') || String(GetStatusGlobal('page_sub')));

    useEffect(() => {
        function AltPageSub(value: boolean | string | number){
            setPageSub(String(value));
        }

        RegisterStatusGlobal('page_sub', AltPageSub);
        return ()=>{
            UnRegisterStatusGlobal('page_sub', AltPageSub);
        };
    }, []);

    switch (pageSub) {
        case 'general':
            return <Page_Reports_General />;

        case 'units':
            return <Page_Reports_Units />;

        case 'floorplans':
            return <Page_Reports_Floorplans />;

        default:
            return (
                <div className="Page_Reports">
                    <div className="click_page">
                        Select a report option in the side menu.
                    </div>
                </div>
            );
    }
}
